
import { useMutation } from 'react-query';
import { fetchData } from './fetchData';
import { blobToBase64 } from '../helper/commonHelpers';
import { APIError } from './useErrorMessageMapping';
import { useTranslation } from 'react-i18next';


export const useImageData = (api_key: string, personalization_id: string, onSuccessCallback: (data: any) => void, handleError: (error: unknown) => void) => {
    const { t } = useTranslation()
    const fetchImageData = async (): Promise<any> => {
        try {
            const response = await fetchData<any>(`/configurator/sessions/personalizations/${personalization_id}/download`, api_key, 'blob');

            if (response.status === 200) {
                // Try to extract filename from headers if API provides it
                // Read filename from custom header 'x-filename'
                const fileName = response.headers['x-filename'] || 'preview.jpg';
                const contentType = response.headers['content-type'] || 'image/jpeg';

                // Ensure blob has proper type
                const blob = new Blob([response.data], { type: contentType });

                return {
                    file_name: fileName,
                    blob: blob,
                };
            }
            else {
                const apiError: APIError[] = [
                    { key: "generic", source: "generic", message: t("error.message") }
                ];
                handleError(apiError)

                //   alert("Error in downloading production info. Try it again");
                // Notify parent app to close
                // onSuccessCallback({ command: 'CLOSE' });

                //  Still throw so react-query marks query as failed
                throw new Error(`fetchImageData Error fetching info data`);
            }
        }
        catch (error: any) {
            console.log("fetchImageData Error:", error);
            console.log(' Error in fetchImageData:', JSON.stringify(error));

            // // Show generic alert for 400 / 500, descriptive for others
            if (error.status === 500) {
                // alert("Error in downloading production info. Try it again");
                const apiError: APIError[] = [
                    { key: "generic", source: "generic", message: t("error.message") }
                ];
                handleError(apiError)

            } else {
                let apiError: APIError[] = [
                    { key: "generic", source: "generic", message: t("error.message") }
                ];
                console.log("fetchImageData error.data?.[0] ", error.data?.[0])
                if (error.data?.[0]) {
                    apiError = [error.data?.[0]]
                }
                handleError(apiError)
            }

            // // Notify parent app to close
            // onSuccessCallback({ command: 'CLOSE' });

            // //  Still throw so react-query marks query as failed
            throw new Error(`fetchImageData Error fetching info data`);

        }
    };

    return useMutation(fetchImageData, {
        onSuccess: async (data) => {
            try {
                // Convert Blob to Base64 data URL
                const base64String = await blobToBase64(data.blob);
                console.log('fetchImageData Base64 preview:', base64String.slice(0, 100));

                // Correctly assign Base64 to a field called file_base64
                const callbackData = {
                    command: 'LOAD',
                    data: {
                        file_name: data.file_name,
                        file_base64: base64String, // <-- use file_base64 instead of blob
                    }
                };
                const callbackClose = { command: 'CLOSE' };

                // Call the success callback
                if (typeof onSuccessCallback === 'function') {
                    //alert(JSON.stringify(callbackData))
                    //alert("Calling LOAD command");
                    var loadResponse = await onSuccessCallback(callbackData);
                    //alert("LOAD command response: " + JSON.stringify(loadResponse));
                    //alert("Calling CLOSE command");
                    await onSuccessCallback(callbackClose)
                } else {
                    console.error('Callback function is not defined');
                }
            } catch (error) {
                console.error('fetchImageData Error converting Blob to Base64:', error);
            }
        },
        onError: (error: any) => {
            console.error('fetchImageData Error fetching image data:', error);
        },
    });
};